export default {
    SET_VEHICLE_CONVERTERS(state, payload) {
        state.converters = payload;
    },
    SET_VEHICLE_WARRANTY_EXCLUDE_ITEMS(state, payload) {
        state.warranty_excluded_items = payload;
    },
}